import * as React from 'react';
import { createShorthandFactory, commonPropTypes, childrenExist } from '../../utils';
import { useTelemetry, getElementType, useUnhandledProps, useFluentContext, useAccessibility, useStyles } from '@fluentui/react-bindings';
export var dialogFooterClassName = 'ui-dialog__footer';
/**
 * A DialogFooter represents footer content in Dialog, usually shows dialog actions.
 */
export var DialogFooter = /*#__PURE__*/function () {
  var DialogFooter = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var context = useFluentContext();
    var _useTelemetry = useTelemetry(DialogFooter.displayName, context.telemetry),
      setStart = _useTelemetry.setStart,
      setEnd = _useTelemetry.setEnd;
    setStart();
    var children = props.children,
      content = props.content,
      className = props.className,
      design = props.design,
      styles = props.styles,
      variables = props.variables,
      accessibility = props.accessibility;
    var ElementType = getElementType(props);
    var unhandledProps = useUnhandledProps(DialogFooter.handledProps, props);
    var getA11yProps = useAccessibility(accessibility, {
      debugName: DialogFooter.displayName,
      rtl: context.rtl
    });
    var _useStyles = useStyles(DialogFooter.displayName, {
        className: dialogFooterClassName,
        mapPropsToInlineStyles: function mapPropsToInlineStyles() {
          return {
            className: className,
            design: design,
            styles: styles,
            variables: variables
          };
        },
        rtl: context.rtl
      }),
      classes = _useStyles.classes;
    var element = /*#__PURE__*/React.createElement(ElementType, getA11yProps('root', Object.assign({
      className: classes.root,
      ref: ref
    }, unhandledProps)), childrenExist(children) ? children : content);
    setEnd();
    return element;
  });
  DialogFooter.displayName = 'DialogFooter';
  DialogFooter.propTypes = Object.assign({}, commonPropTypes.createCommon());
  DialogFooter.handledProps = Object.keys(DialogFooter.propTypes);
  DialogFooter.create = createShorthandFactory({
    Component: DialogFooter,
    mappedProp: 'content'
  });
  return DialogFooter;
}();
//# sourceMappingURL=DialogFooter.js.map
